import { b as _extends } from './chunk-fb907809.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { theme, ifProp } from 'styled-tools';
import hoistNonReactStatics from 'hoist-non-react-statics';
import styled from './styled.js';
import as from './as.js';
import Overlay from './Overlay.js';
import { a as OverlayContainer, b as OverlayToggle, c as OverlayShow, d as OverlayHide } from './chunk-c23ea417.js';
import 'styled-components';
import '@emotion/is-prop-valid';
import './Hidden.js';
import 'react-dom';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';
import './chunk-d8771a86.js';
import './Box.js';
import './chunk-ac382c96.js';
import 'constate';
import './chunk-6133b9c9.js';

var Component = function Component(props) {
  return React__default.createElement(Overlay, _extends({
    defaultSlide: props.align === "right" ? "left" : "right"
  }, props));
};

hoistNonReactStatics(Component, Overlay);
var Sidebar = styled(Component).withConfig({
  displayName: "Sidebar",
  componentId: "sc-12huw2s-0"
})(["top:0;height:100vh;transform:none;overflow:auto;left:", ";right:", ";", ";"], ifProp({
  align: "right"
}, "auto", 0), ifProp({
  align: "right"
}, 0, "auto"), theme("Sidebar"));
Sidebar.propTypes = {
  align: PropTypes__default.oneOf(["left", "right"])
};
Sidebar.defaultProps = {
  align: "left",
  translateX: 0,
  translateY: 0
};
var Sidebar$1 = as("div")(Sidebar);

var SidebarContainer = OverlayContainer;

var SidebarToggle = styled(OverlayToggle).withConfig({
  displayName: "SidebarToggle",
  componentId: "sc-19dw4y3-0"
})(["", ";"], theme("SidebarToggle"));
var SidebarToggle$1 = as("button")(SidebarToggle);

var SidebarShow = styled(OverlayShow).withConfig({
  displayName: "SidebarShow",
  componentId: "sc-1yh5wt4-0"
})(["", ";"], theme("SidebarShow"));
var SidebarShow$1 = as("button")(SidebarShow);

var SidebarHide = styled(OverlayHide).withConfig({
  displayName: "SidebarHide",
  componentId: "sc-1ql5re7-0"
})(["", ";"], theme("SidebarHide"));
var SidebarHide$1 = as("button")(SidebarHide);

Sidebar$1.Container = SidebarContainer;
Sidebar$1.Toggle = SidebarToggle$1;
Sidebar$1.Show = SidebarShow$1;
Sidebar$1.Hide = SidebarHide$1;

export default Sidebar$1;
